import { makeStyles } from '@mui/styles'
import PageMetaData from '@v4/utils/data/PageMetaData'

const useStyles = makeStyles(
	({ spacing, transitions, breakpoints }) => ({
		image: {
			display: 'flex',
			transition: transitions.create(['all']),
			alignItems: 'center',
			maxHeight: '100%',
			minHeight: spacing(8),
			height: 'auto',
			textAlign: 'center',
			[breakpoints.down('md')]: {
				maxWidth: ({ metaData }) => `${Math.round(metaData.size?.toNumber() / 1.4)}px`,
			},
			[breakpoints.up('md')]: {
				maxWidth: ({ metaData }) => `${metaData.size?.toNumber()}px`,
			},
			'& img': {
				width: '100%',
				margin: '0 auto',
			},
		},
		text: {
			width: '100%',
		},
		textWrap: {},
		container: {},
		empty: {},
		logoWrap: {
			marginLeft: 'auto',
			marginRight: 'auto',
		},
		[breakpoints.down('sm')]: {
			empty: {
				display: 'none !important',
			},
			[PageMetaData.ALIGNMENT.CENTER]: {
				flexDirection: 'column',
				'& $text': {
					textAlign: 'center',
				},
			},
			textWrap: {
				width: '100%',
			},
		},
		[PageMetaData.ALIGNMENT.RIGHT]: {
			'& $logoWrap': {
				display: 'flex',
				flexDirection: 'row-reverse',
			},
		},
		[PageMetaData.ALIGNMENT.CENTER]: {
			'& $textWrap': {
				display: 'flex',
				justifyContent: 'flex-end',
			},
			[breakpoints.up('sm')]: {
				'& $text': {
					textAlign: 'right',
				},
			},
		},
	}),
	{ name: 'Footer-Footer1' },
)

export default useStyles
